/* eslint-disable @typescript-eslint/ban-types */
import * as React from 'react';

import { DynamicOptions, dynamicWithProps, Loader } from './dynamicWithProps';

// import dynamic from 'next/dynamic';

export function dynamicEditorComponent<P = {}>(
  dynamicOptions: DynamicOptions<P> | Loader<P>,
  options?: DynamicOptions<P>
): any {
  return dynamicWithProps(dynamicOptions, {
    loading: ({ props }) => <div {...props?.attributes}>{props?.children}</div>,
    ...options,
  });
}
